/* import __COLOCATED_TEMPLATE__ from './footer.hbs'; */
import templateOnly from '@ember/component/template-only';

export interface BvModalFooterSignature {
  Args: {
    sticky?: boolean;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const BvModalFooterComponent = templateOnly<BvModalFooterSignature>('BvModal::Footer');

export default BvModalFooterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvModal::Footer': typeof BvModalFooterComponent;
    'bv-modal/footer': typeof BvModalFooterComponent;
  }
}
